import { useFormContext } from 'react-hook-form';
// Ui
import Text from 'ui3/Text/Text';
import Switch from 'ui3/Switch/Switch';
// Components
import StreamOptionRow, {
  FAN_ENGAGEMENT_OPTIONS,
  StreamOptionRows,
} from 'components/common3/StreamOptionRow/StreamOptionRow';
// Styles
import styles from './FanEngagementSection.module.scss';

type FanEngagementFormFields = {
  fanPollingEnabled: boolean;
  sharePickGraphicsEnabled: boolean;
};

const FIELDS = Object.keys(
  FAN_ENGAGEMENT_OPTIONS
) as (keyof typeof FAN_ENGAGEMENT_OPTIONS)[];

type FanEngagementSectionProps = {
  disabled?: boolean;
  pickGraphicsDisabled?: boolean;
  /** Why pick graphics are unavailable, shown under the option. */
  pickGraphicsNote?: string;
};

const FanEngagementSection = ({
  disabled,
  pickGraphicsDisabled,
  pickGraphicsNote,
}: FanEngagementSectionProps): JSX.Element => {
  const { register } = useFormContext<FanEngagementFormFields>();

  const isFieldDisabled = (field: keyof FanEngagementFormFields) =>
    Boolean(
      disabled || (field === 'sharePickGraphicsEnabled' && pickGraphicsDisabled)
    );

  return (
    <div className={styles.root}>
      <div className={styles.heading}>
        <Text variant="body1Medium16">Fan Engagement</Text>
        <Text variant="body1Regular16" color="lights-medium">
          Customize your event with fan engagement features.
        </Text>
      </div>

      <StreamOptionRows>
        {FIELDS.map((field) => (
          <StreamOptionRow
            key={field}
            {...FAN_ENGAGEMENT_OPTIONS[field]}
            disabled={isFieldDisabled(field)}
            note={
              field === 'sharePickGraphicsEnabled'
                ? pickGraphicsNote
                : undefined
            }
          >
            <Switch
              wrapperClassName={styles.switch}
              name={field}
              ref={register}
              disabled={isFieldDisabled(field)}
            />
          </StreamOptionRow>
        ))}
      </StreamOptionRows>
    </div>
  );
};

export default FanEngagementSection;
